import Delegate from 'OK/utils/delegate';
import { ajax } from 'OK/utils/utils';
import { seek, showTooltip, hideTooltip } from 'OK/OKVideo';
import { firstByClass, byClass, parent } from 'OK/utils/dom';
import logger from 'OK/logger';

var CSS_CLASS_PINS_EXPANDED_STATE = '__is-expanded',
    CSS_CLASS_CONFIRMED_PINS_EXPANDED_STATE = '__full',
    CSS_CLASS_INVISIBLE = 'invisible'
    ;

var LOG_NAME = "video.pins",
    LOG_SEEK = "seekSuccess",
    LOG_SEEK_FAIL = "seekFail",
    LOG_SEEK_PREVIEW_SHOW = "seekPreviewShow",
    LOG_SEEK_PREVIEW_HIDE = "seekPreviewHide",
    LOG_SHOW_UNCONFIRMED = "showAllUnconfirmed",
    LOG_CANCEL_UNCONFIRMED = "cancelUnconfirmed",
    LOG_CLOSE_UNCONFIRMED = "closeAllUnconfirmed",
    LOG_REJECT_UNCONFIRMED = "rejectUnconfirmed",
    LOG_RESTORE_UNCONFIRMED = "restoreUnconfirmed",
    LOG_REJECT_CONFIRMED = "rejectConfirmed",
    LOG_CONFIRM = "confirm";


class VideoPin {
    constructor(el) {
        this.el = el;
        this.userId = parseInt(el.getAttribute('data-id'), 10);
        this.confirmed = el.getAttribute('data-confirm') === 'true';
        this.removed = false;
    }
}

export default class VideoLayerPins {
    activate(element) {
        this.hook = element;
        this.delegator = new Delegate(element);

        this.unconfirmedPinsContainer = firstByClass(this.hook, 'unconfirmed-pins');
        this.unconfirmedPinsList = firstByClass(this.hook, 'unconfirmed-pins_list');
        this.unconfirmedPinsDelegator = new Delegate(this.unconfirmedPinsContainer);

        this.confirmedPinsContainer = firstByClass(this.hook, 'confirmed-pins');
        this.confirmedPinsListWrapper = firstByClass(this.confirmedPinsContainer, 'confirmed-pins_list-w');
        this.confirmedPinsList = firstByClass(this.confirmedPinsContainer, 'confirmed-pins_list');
        this.confirmedPinsListExpand = firstByClass(this.confirmedPinsContainer, 'confirmed-pins_list-expand');
        this.confirmedPinsDelegator = new Delegate(this.confirmedPinsContainer);

        this.removedPinsContainer = firstByClass(element, 'unconfirmed-pins_removed');
        this.removedPinsList = firstByClass(element, 'unconfirmed-pins_removed-pins');
        this.removedPinsCounter = firstByClass(element, 'unconfirmed-pins_removed_counter');

        this.videoPins = [];
        var _videoPins = byClass(this.hook, 'js-video-pin');
        var _this = this;
        _videoPins.forEach(function (pin) {
            _this.videoPins.push(new VideoPin(pin));
        });

        var pinTester = firstByClass(this.confirmedPinsList, 'js-video-pin');
        if (pinTester) {
            var pinTesterBottomMargin = parseInt(window.getComputedStyle(pinTester).getPropertyValue('margin-bottom'), 10);
            var pinTesterHeight = pinTester.offsetHeight + (isNaN(pinTesterBottomMargin) ? 0 : pinTesterBottomMargin);
            var maxHeight = pinTesterHeight * 3;
            var showExpandControl = this.confirmedPinsList.clientHeight > maxHeight;
            this.confirmedPinsListExpand.classList.toggle(CSS_CLASS_INVISIBLE, !showExpandControl);
        }

        this.movieId = this.hook.getAttribute('data-movie-id');

        this.delegator.on('click', '.js-video-pin-seek', function () {
            var currentPin = parent(this, 'js-video-pin');
            var timestamp = parseInt(currentPin.getAttribute('data-st'), 10);
            if (!isNaN(timestamp)) {
                seek(timestamp / 1000, true);
                logger.success(LOG_NAME, LOG_SEEK);
            } else {
                logger.success(LOG_NAME, LOG_SEEK_FAIL);
            }
        });

        this.delegator.on('mouseover', '.js-video-pin-seek', function () {
            var currentPin = parent(this, 'js-video-pin');
            var timestamp = parseInt(currentPin.getAttribute('data-t'), 10);
            if (!isNaN(timestamp)) {
                showTooltip(timestamp / 1000);
                logger.success(LOG_NAME, LOG_SEEK_PREVIEW_SHOW);
            }
        });

        this.delegator.on('mouseout', '.js-video-pin-seek', function () {
            var currentPin = parent(this, 'js-video-pin');
            var timestamp = parseInt(currentPin.getAttribute('data-t'), 10);
            if (!isNaN(timestamp)) {
                hideTooltip();
                logger.success(LOG_NAME, LOG_SEEK_PREVIEW_HIDE);
            }
        });

        this.confirmedPinsDelegator.on('click', '.js-video-pin-remove', function () {
            var _removedPin = parent(this, 'js-video-pin'),
                userId = parseInt(_removedPin.getAttribute('data-id'), 10),
                index = _this.videoPins.findIndex(function (pin) {
                    return pin.userId === userId;
                });

            if (index < 0) {
                return;
            }

            _this.videoPins.splice(index, 1);
            _removedPin.parentNode.removeChild(_removedPin);

            var confirmedPins = _this.confirmedPinsList.querySelectorAll('.js-video-pin');
            _this.confirmedPinsContainer.classList.toggle(CSS_CLASS_INVISIBLE, confirmedPins.length === 0);
            _this.removeSinglePin(userId);
            logger.success(LOG_NAME, LOG_REJECT_CONFIRMED);
        });

        this.confirmedPinsDelegator.on('click', '.js-confirmed-pins-expand', function () {
            _this.confirmedPinsListExpand.classList.add(CSS_CLASS_INVISIBLE);
            _this.confirmedPinsListWrapper.classList.add(CSS_CLASS_CONFIRMED_PINS_EXPANDED_STATE);
        });

        this.unconfirmedPinsDelegator.on('click', '.js-video-pin-remove', function () {
            var _removedPin = parent(this, 'js-video-pin');

            var index = _this.videoPins.findIndex(function (pin) {
                return pin.userId === parseInt(_removedPin.getAttribute('data-id'), 10);
            });

            if (index < 0) {
                return;
            }

            var pin = _this.videoPins[index];
            pin.removed = true;

            _this.updateUI();
            logger.success(LOG_NAME, LOG_REJECT_UNCONFIRMED);
        });

        this.unconfirmedPinsDelegator.on('click', '.js-video-pin-restore', function () {
            var restoredPin = parent(this, 'js-video-pin');

            var index = _this.videoPins.findIndex(function (pin) {
                return pin.userId === parseInt(restoredPin.getAttribute('data-id'), 10);
            });

            if (index < 0) {
                return;
            }

            var pin = _this.videoPins[index];
            pin.removed = false;

            _this.updateUI();
            logger.success(LOG_NAME, LOG_RESTORE_UNCONFIRMED);
        });


        this.unconfirmedPinsDelegator.on('click', '.js-show-all', function () {
            _this.unconfirmedPinsContainer.classList.add(CSS_CLASS_PINS_EXPANDED_STATE);
            logger.success(LOG_NAME, LOG_SHOW_UNCONFIRMED);
        });

        this.unconfirmedPinsDelegator.on('click', '.js-cancel', function () {
            _this.unconfirmedPinsContainer.classList.remove(CSS_CLASS_PINS_EXPANDED_STATE);
            _this.unconfirmedPinsContainer.scrollIntoView({block: "end", behavior: "smooth"});
            logger.success(LOG_NAME, LOG_CANCEL_UNCONFIRMED);
        });

        this.unconfirmedPinsDelegator.on('click', '.js-confirm-all', function () {
            _this.submit();
            _this.updateUI();
            _this.unconfirmedPinsContainer.classList.add(CSS_CLASS_INVISIBLE);
            logger.success(LOG_NAME, LOG_CONFIRM);
        });

        this.unconfirmedPinsDelegator.on('click', '.js-close-all', function () {
            _this.unconfirmedPinsContainer.classList.add(CSS_CLASS_INVISIBLE);
            logger.success(LOG_NAME, LOG_CLOSE_UNCONFIRMED);
        });
    }

    updateUI() {
        var confirmedPins = [], unconfirmedPins = [], removedPins = [];

        for (var i = 0; i < this.videoPins.length; i++) {
            var _pin = this.videoPins[i];
            if (_pin.confirmed) {
                confirmedPins.push(_pin);
            } else if (_pin.removed) {
                removedPins.push(_pin);
            } else {
                unconfirmedPins.push(_pin);
            }
        }

        if (confirmedPins.length) {
            var frg = document.createDocumentFragment();
            confirmedPins.forEach(function (pin) {
                frg.appendChild(pin.el);
            });

            this.confirmedPinsList.innerHTML = '';
            this.confirmedPinsList.appendChild(frg);
        }
        this.confirmedPinsContainer.classList.toggle(CSS_CLASS_INVISIBLE, confirmedPins.length === 0);

        if (unconfirmedPins.length) {
            var frg2 = document.createDocumentFragment();
            unconfirmedPins.forEach(function (pin) {
                frg2.appendChild(pin.el);
            });
            this.unconfirmedPinsList.innerHTML = '';
            this.unconfirmedPinsList.appendChild(frg2);
        }

        if (removedPins.length) {
            var frg3 = document.createDocumentFragment();
            removedPins.forEach(function (pin) {
                frg3.appendChild(pin.el);
            });
            this.removedPinsList.innerHTML = '';
            this.removedPinsList.appendChild(frg3);
        }
        this.removedPinsContainer.classList.toggle(CSS_CLASS_INVISIBLE, removedPins.length === 0);
        this.removedPinsCounter.textContent = removedPins.length;
    }

    deactivate() {
        this.delegator.off();
        this.unconfirmedPinsDelegator.off();
        this.confirmedPinsDelegator.off();
    }

    submit() {
        var confirmUsers = [], rejectUsers = [];

        for (var i = 0; i < this.videoPins.length; i++) {
            var pin = this.videoPins[i];

            // на сабмите считаем что все пины что не скрыли, являются подтвержденными
            if (pin.removed) {
                rejectUsers.push(pin.userId);
            } else {
                pin.confirmed = true;
                confirmUsers.push(pin.userId);
            }
        }

        ajax({
            type: 'POST',
            url: '/web-api/video/pins/' + this.movieId,
            data: {
                'confirmUsers': confirmUsers,
                'rejectUsers': rejectUsers
            }
        });
    }

    removeSinglePin(userId) {
        ajax({
            type: 'POST',
            url: '/web-api/video/pins/' + this.movieId,
            data: {
                'confirmUsers': [],
                'rejectUsers': [userId]
            }
        });
    }
}
